import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 lg:py-32 bg-[#F9F9F9]" data-id="element-434" data-mp="38xok4ys74qwl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-435" data-mp="38xeu5b75ijqw">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-436" data-mp="2uyx6fdh8x78z">
          {/* Sticky heading rail */}
          <div className="lg:col-span-5" data-id="element-437" data-mp="2yyz8hnqw82os">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1]
          }} className="lg:sticky lg:top-32" data-id="element-438" data-mp="2z1twtqd127nh">
              <span className="text-[11px] tracking-[0.25em] font-bold uppercase text-[#C8102E]" data-id="element-439" data-mp="2b8bow57m7ome">
                The Honest Truth
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-[1.05] mt-4" data-id="element-440" data-mp="22ajad39pwl02">
                YOU'VE BEEN
                <br data-id="element-441" data-mp="277rtb62owt2d" />
                CARRYING THIS
                <br data-id="element-442" data-mp="3rmhlgusali5t" />
                <span className="text-[#C8102E]" data-id="element-443" data-mp="3rlzjrimv2bqi">LONG ENOUGH.</span>
              </h2>
              <div className="w-16 h-1 bg-[#C8102E] mt-6 rounded-full" data-id="element-444" data-mp="3nm746lz1v5bn" />
            </motion.div>
          </div>

          {/* Narrative */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-7" data-id="element-445" data-mp="5f16qakgko3c">
            <p className="font-oswald text-3xl md:text-4xl text-[#1A1A1A] mb-8 leading-tight" data-id="element-446" data-mp="33z9gyf2oud4u">
              You know the pile.
            </p>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-447" data-mp="3dv467t1f36gl">
              Maybe it's the garage full of furniture you told yourself you'd
              sell. Maybe it's the backyard stacked with old construction debris
              from a project that wrapped up six months ago. Maybe it's a
              property you inherited, a unit your tenant left destroyed, or a
              business space that became a dumping ground when no one was paying
              attention.
            </p>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-448" data-mp="yt3ove9hexyj">
              Whatever it is — it's been there longer than you'd like to admit.
            </p>

            {/* Pull quote */}
            <blockquote className="relative bg-white border border-gray-200 rounded-2xl p-8 md:p-10 shadow-sm mb-10" data-id="element-449" data-mp="65pwltgqaqkr">
              <span className="absolute -top-4 left-8 bg-[#C8102E] text-white text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1.5 rounded-full" data-id="element-450" data-mp="b4u4mgrx2i9i">
                And here's the thing
              </span>
              <p className="text-xl md:text-2xl font-medium text-[#1A1A1A] leading-snug" data-id="element-451" data-mp="k6agksydqsfu">
                You're not lazy. You're not irresponsible. You're just busy — and
                this kind of work requires a truck, a team, the physical energy,
                <span className="text-[#C8102E]" data-id="element-452" data-mp="25njgsc2blvpo"> and </span>
                the time to make multiple dump runs.
              </p>
            </blockquote>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-453" data-mp="20phznwogg6gu">
              Most people never get all four lined up at once.
            </p>

            <p className="font-oswald text-4xl md:text-5xl text-[#1A1A1A] leading-none" data-id="element-454" data-mp="1rwxzuswffvuf">
              SO THE PILE <span className="text-[#C8102E]" data-id="element-455" data-mp="1mxld085k2oru">STAYS.</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}